module.exports = __webpack_public_path__ + "img/shoplaza.25cb771.png";